import React from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import Nav from '../Pages/Shared/Navigation/Nav';
import Sidebar from '../Pages/Shared/Sidebar/Sidebar';

const glass = {
  background: 'rgba(8, 8, 14, 0.78)',
  backdropFilter: 'blur(32px)',
  WebkitBackdropFilter: 'blur(32px)',
  border: '1px solid rgba(250,204,21,0.11)',
  boxShadow: '0 8px 40px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.06), inset 0 -1px 0 rgba(0,0,0,0.3)',
  borderRadius: '16px',
}

const Main = () => (
  <section
    className='grid md:grid-cols-12 lg:grid-rows-[80px_minmax(500px,_1fr)] gap-4 mx-auto lg:p-0 lg:py-5 p-3 max-w-[1200px] w-full'
    style={{ position: 'relative', zIndex: 1 }}
  >
    <div className='hidden order-2 col-span-full md:block lg:row-span-full lg:col-span-3'>
      <Sidebar />
    </div>

    <div
      className='order-1 col-span-full lg:col-start-7 lg:col-end-13 flex items-center px-4 justify-end'
      style={glass}
    >
      <Nav />
    </div>

    <div
      className='order-3 px-5 py-10 md:p-10 col-span-full row-span-auto lg:col-span-9 min-h-[520px] lg:max-h-[calc(100vh-140px)] lg:overflow-y-auto outlet-scroll'
      style={glass}
    >
      <ScrollRestoration />
      <Outlet />
    </div>
  </section>
)

export default Main;
